module.exports = __webpack_public_path__ + "static/media/bg.30b30a4d.jpg";